
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reference",
      function () {
        return require("private-next-pages/reference.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reference"])
      });
    }
  